var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-black text-2xl font-semibold mb-1"},[_vm._v(" Tambah talent ")]),_c('Bio')],1)}
var staticRenderFns = []

export { render, staticRenderFns }